// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import vi from './vi/vi.json';
import en from './en/en.json'

const resources = {
  vi: {
    translation: vi,
  },
  en: {
    translation: en,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'vi',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
